// 팝업의 확인 버튼
const ConfirmButtonBox = ({ title, onClick }) => {
    return (
        <button type='button' className='btn confirm' onClick={(e) => onClick(e)}>
            {title}
        </button>
    );
};

export default ConfirmButtonBox;
